import React from 'react';
import PropTypes from 'prop-types';

import Row from 'components/Layout/Row';
import Column from 'components/Layout/Column';

import { Main } from './LoginLayout.styled';

const LoginLayout = ({ children, style = {} }) => (
  <Main>
    <Row className="login-row">
      <Column className="center">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        {window.location.origin === 'https://app.ruttl.com' ||
        window.location.origin === 'https://staging.ruttl.com' ? (
          <video
            src="/assets/video/login-intro.mp4"
            autoPlay
            muted
            loop
            playsInline
          />
        ) : (
          <div className="login-banner" />
        )}
      </Column>
      <Column>
        <div className="login-container" style={style}>
          {children}
        </div>
      </Column>
    </Row>
  </Main>
);

LoginLayout.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default LoginLayout;
